export const paginationFactoryConfig = {
  hidePageListOnlyOnePage: true,
  hideSizePerPage: true,
  sizePerPageList: [10, 25],
};
